module.exports = __webpack_public_path__ + "media/images/games/k2gender/eggspr-11ee4ea070e2f4cb64ccc2c7d6ef2783.png";